// extracted by mini-css-extract-plugin
export default {"policy":"policy-body_policy__Tbo7u","fixed-header":"policy-body_fixed-header__4240l","text":"policy-body_text__YnTj4"};